/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './watchlist.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../ui-core-shared/components/page/page.component.ngfactory';
import * as i3 from '@nw/ui-core-shared/components/page/page.component';
import * as i4 from './vehicle-list/vehicle-list.component.ngfactory';
import * as i5 from '@nw/ui-watchlist/components/vehicle-list/vehicle-list.component';
import * as i6 from '@ngrx/store/src/store';
import * as i7 from '@nw/ui-watchlist/shared/services/vehicle-liveblock-auction.service';
import * as i8 from '@nw/ui-core-shared/store/main-store.service';
import * as i9 from '@nw/ui-watchlist/store/actions/WatchListActions';
import * as i10 from '@nw/ui-watchlist/shared/services/vehicle-sort.service';
import * as i11 from '@nw/ui-core-shared/services/language.service';
import * as i12 from '@nw/ui-watchlist/shared/services/vehicle-filter.service';
import * as i13 from '@nw/ui-core-shared/services/environment.service';
import * as i14 from '@nw/ui-watchlist/shared/services/vehicles.service';
import * as i15 from '@ngx-translate/core/src/translate.service';
import * as i16 from '@nw/ui-core-shared/store/actions/app-ui.action';
import * as i17 from '@nw/ui-core-shared/services/export-pdf-excel.service';
import * as i18 from '@angular/router';
import * as i19 from '@nw/ui-watchlist/components/watchlist.component';
import * as i20 from '@nw/ui-watchlist/shared/services/iot-handler.service';
const styles_WatchlistComponent:any[] = [i0.styles];
export const RenderType_WatchlistComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_WatchlistComponent,data:{}});
export function View_WatchlistComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'nw-page',([] as any[]),
      [[40,'@routeAnimation',0],[4,'display',(null as any)]],(null as any),(null as any),
      i2.View_PageComponent_0,i2.RenderType_PageComponent)),i1.ɵdid(1,114688,(null as any),
      0,i3.PageComponent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,
      0,['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),0,1,'nw-vehicle-list',([] as any[]),
      (null as any),(null as any),(null as any),i4.View_VehicleListComponent_0,i4.RenderType_VehicleListComponent)),
      i1.ɵdid(4,245760,(null as any),0,i5.VehicleListComponent,[i6.Store,i7.VehicleLiveblockAuctionService,
          i8.MainStoreService,i9.WatchListActions,i10.VehicleSortService,i11.LanguageService,
          i12.VehicleFilterService,i13.EnvironmentService,i14.VehiclesService,i15.TranslateService,
          i16.AppUiActions,i17.ExportPdfExcelService,i18.Router],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,0,['\n']))],(_ck,_v) => {
    _ck(_v,1,0);
    _ck(_v,4,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).routeAnimation;
    const currVal_1:any = i1.ɵnov(_v,1).display;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export function View_WatchlistComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'nw-watchlist',
      ([] as any[]),(null as any),(null as any),(null as any),View_WatchlistComponent_0,
      RenderType_WatchlistComponent)),i1.ɵdid(1,114688,(null as any),0,i19.WatchlistComponent,
      [i6.Store,i8.MainStoreService,i20.IotHandlerService,i15.TranslateService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WatchlistComponentNgFactory:i1.ComponentFactory<i19.WatchlistComponent> = i1.ɵccf('nw-watchlist',
    i19.WatchlistComponent,View_WatchlistComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL3dhdGNobGlzdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9uZXctd2F2ZS0tbnctYWRlc2EtdWktcGlwZWxpbmUvc291cmNlL25vZGVfbW9kdWxlcy9AbncvdWktd2F0Y2hsaXN0L2NvbXBvbmVudHMvd2F0Y2hsaXN0LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL3dhdGNobGlzdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL3dhdGNobGlzdC5jb21wb25lbnQudHMuV2F0Y2hsaXN0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG53LXBhZ2U+XG4gIDxudy12ZWhpY2xlLWxpc3Q+PC9udy12ZWhpY2xlLWxpc3Q+XG48L253LXBhZ2U+IiwiPG53LXdhdGNobGlzdD48L253LXdhdGNobGlzdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTt5REFBQSxVQUFBO01BQUEsOERBQVM7TUFBQSxhQUNQO01BQUE7YUFBQTs7OytEQUFBO01BQW1DO0lBRHJDO0lBQ0U7O0lBREY7SUFBQTtJQUFBLFdBQUEsbUJBQUE7Ozs7b0JDQUE7TUFBQTttQ0FBQSxVQUFBO01BQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/node_modules/@nw/ui-watchlist/components/watchlist.component.ngfactory.ts